var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.792 2.91602H10.2087C6.18158 2.91602 2.91699 6.18061 2.91699 10.2077V24.791C2.91699 28.8181 6.18158 32.0827 10.2087 32.0827H24.792C28.8191 32.0827 32.0837 28.8181 32.0837 24.791V10.2077C32.0837 6.18061 28.8191 2.91602 24.792 2.91602Z",
    stroke: "#0073FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 16.5812C23.514 17.7949 23.3067 19.0344 22.7416 20.1235C22.1765 21.2126 21.2824 22.0958 20.1864 22.6474C19.0905 23.199 17.8484 23.391 16.6371 23.1961C15.4257 23.0012 14.3066 22.4292 13.439 21.5616C12.5714 20.6941 11.9995 19.575 11.8046 18.3636C11.6096 17.1522 11.8016 15.9102 12.3533 14.8142C12.9049 13.7183 13.7881 12.8242 14.8771 12.2591C15.9662 11.694 17.2058 11.4866 18.4195 11.6666C19.6575 11.8502 20.8036 12.4271 21.6886 13.3121C22.5736 14.197 23.1505 15.3432 23.334 16.5812Z",
    stroke: "#0073FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5215 9.47852H25.5352",
    stroke: "#0073FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7d3279a007bf6eec4ed712d80816514b.svg";
export { ForwardRef as ReactComponent };